import { Component, Input, OnInit } from '@angular/core';
import {
  Section84_1Result,
} from '../../../../../../../../../../../common/dist/angular/results/calculations/section-84_1/section-84_1.result';
import {
  Section84_1ShareClassResult,
} from '../../../../../../../../../../../common/dist/angular/results/calculations/section-84_1/section-84_1-share-class.result';
import {
  Section84_1ShareClassOptions,
} from '../../../../../../../../../../../common/src/options/calculations/section-84_1/section-84_1-share-class.options';
import {
  Section84_1Options,
} from '../../../../../../../../../../../common/src/options/calculations/section-84_1/section-84_1.options';

@Component({
  selector: 'app-section-84_1-share-class-result',
  templateUrl: './section-84_1-share-class-result.component.html',
  styleUrls: ['./section-84_1-share-class-result.component.scss'],
  standalone: false,
})
export class Section84_1ShareClassResultComponent implements OnInit {

  isSectionShareClassCollapsed: boolean;
  isSectionShareClassTableCollapsed: boolean;
  isSectionPaidUpCapitalCollapsed: boolean;
  isSectionReducedPaidUpCapitalCollapsed: boolean;

  @Input()
  selectedBadge: string;

  @Input()
  index: number;

  @Input()
  shareClassOptions: Section84_1ShareClassOptions;
  @Input()
  shareClassResults: Section84_1ShareClassResult;
  @Input()
  options: Section84_1Options;
  @Input()
  results: Section84_1Result;

  constructor() {
  }

  ngOnInit(): void {
  }
}
